import { Flex, Text } from '@adsk/alloy-react-box'
import React from 'react'
import Theme from '@adsk/alloy-react-theme'
import {
	ModalContextProps,
	useModalContext,
	AlloyModal,
} from '@adsk/napi-shared'
import {
	OnboardingUserAppContextType,
	useOnboardingUserContext,
} from '../../../store'
import { useTranslation } from '../../../../i18n'

const HeaderComponent = (): JSX.Element => {
	const { typography } = Theme
	const { closeModal } = useModalContext() as ModalContextProps
	const { externalProps } =
		useOnboardingUserContext() as OnboardingUserAppContextType
	const { t } = useTranslation()
	return (
		<Flex justifyContent={'space-between'} width={'100%'}>
			<Text
				style={{
					...typography.heading1,
					order: 1,
				}}
			>
				{t('VIEW_PROFILE_HEADER')}
			</Text>
			<AlloyModal.Close
				aria-label="close"
				onClick={() => {
					externalProps?.setShowModal?.(false)
					closeModal()
				}}
				style={{
					order: 2,
				}}
			/>
		</Flex>
	)
}
export default HeaderComponent
